'use client';

import {useContext} from 'react';

import CSS from './CookieToggle.module.scss';
import Vector from '@/components/elements/vector/Vector';
import Switch from '@/components/elements/Switch';
import {SettingContext} from '@/context/Setting';

export default function CookieToggle() {
  const [setting, setSetting] = useContext(SettingContext)!;

  return (
    <div className={CSS.cookieToggle}>
      <Vector name="LuCookie" className={CSS.icon} svgProps={{size: '1rem'}} />
      کوکی‌های آماری
      <Switch
        className={CSS.toggle}
        isOn={setting.cookieConsent.googleAnalytics}
        callback={() =>
          setSetting(state => ({
            ...state,
            cookieConsent: {
              showWarning: false,
              googleAnalytics: !state.cookieConsent.googleAnalytics
            }
          }))
        }
      />
    </div>
  );
}
